import { PagePending } from "@/components/ui/PagePending";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { TabNav, TabNavItem } from "@/components/ui/TabNav";
import { Box } from "@givenwell/components";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/settings")({
  pendingComponent: PagePending,
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageWrapper maxWidth={1400} title="Settings">
      <Box css={{ pb: 16 }}>
        <TabNav>
          <TabNavItem from="/supporter/$supporterId/settings" to="./billing">
            Billing
          </TabNavItem>
          <TabNavItem from="/supporter/$supporterId/settings" to="./countries">
            International
          </TabNavItem>
          <TabNavItem from="/supporter/$supporterId/settings" to="./givenwell-terms">
            Givenwell Terms
          </TabNavItem>
        </TabNav>
      </Box>
      <Outlet />
    </PageWrapper>
  );
}
